export default __webpack_public_path__ + "static/media/error.26e9f864.png";